module.exports = __webpack_public_path__ + "static/gallery_peak_3_thumb-528596689da29ae4cbb60575e06df220.jpg";